import { FC } from 'react';

import type { FieldRendererProps } from '../../../Info/fields/Fields.types';
import { PlainFieldRenderer } from '../../../Info/fields/PlainFieldRenderer';
import { Flag } from '../Flag';
import { ItemType } from '../ItemType';
import { Location } from '../Location';

/** Item fields with their own component (`location`, `flag`, `itemTypeId`); the rest render plain. */
export const FieldRenderer: FC<FieldRendererProps> = ({ field, ...options }) => {
	switch (field.id) {
		case 'location':
			return <Location />;
		case 'flag':
			return <Flag />;
		case 'itemTypeId':
			return <ItemType />;
		default:
			return <PlainFieldRenderer field={field} {...options} />;
	}
};
